<template>
  <div
    id="colum"
    :style="{ width: clientW + 'px', minHeight: clientH + 'px' }"
    style="margin: 0 auto"
    :class="screenParm"
  >
  
    <!-- <div class="topline">
            <img :src="imgPath+'topline.png'" alt="">
        </div>
        <div class="bottomline">
            <img :src="imgPath+'bottomline.png'" alt="">
        </div> -->
    <div class="flower">
      <img :src="imgPath + 'flower.png'" alt="" />
    </div>
    <router-link :to="{ path: '/newflash' }">
      <div class="newflash"  :class="{big:time==1}">
        <img :src="imgPath + 'newflash.png'" alt="" />
      </div>
    </router-link>
    <router-link :to="{ path: '/process' }">
      <div class="process" :class="{big:time==2}">
        <img :src="imgPath + 'processbtn.png'" alt="" />
      </div>
    </router-link>
    <router-link :to="{ path: '/voice' }">
      <div class="voice" :class="{big:time==3}">
        <img :src="imgPath + 'voicebtn.png'" alt="" />
      </div>
    </router-link>
    <router-link :to="{ path: '/live' }">
      <div class="live" :class="{big:time==4}">
        <img :src="imgPath + 'livebtn.png'" alt="" />
      </div>
    </router-link>
    <router-link :to="{ path: '/wqsd' }">
      <div class="wqsd" :class="{big:time==5}">
        <img :src="imgPath + 'wqsdbtn.png'" alt="" />
      </div>
    </router-link>
    <router-link :to="{ path: '/sdkjcontent' }">
      <div class="industry" :class="{big:time==6}">
        <img :src="imgPath + 'industrybtn.png'" alt="" />
      </div>
    </router-link>
    <router-link :to="{ path: '/service' }">
      <div class="service" :class="{big:time==7}">
        <img :src="imgPath + 'servicebtn.png'" alt="" />
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clientW: document.body.clientWidth,
      clientH: document.body.clientHeight,
      imgPath: imgPath,
      screenParm: "",
      time:0
    };
  },
  created() {
    var _this = this;
    _this.time = 1;
    this.getViewScale();
    setInterval(()=>{
        _this.time++
        if(_this.time>7){
            _this.time = 1
        }
    },4000)
  },
  mounted() {
    
    
  },
  watch:{
    '$route' (to,from){
            if(from.path=='/home'){
                // this.$nextTick(()=>{
                //   TweenMax.staggerTo(['.newflash','.process','.voice','.live','.wqsd','.industry','.service'],1,{opacity:1, scale:1,onComplete:()=>{
                //   }},0.5)
                // })
            }
            else{

            }
        }
  },
  methods: {
    getViewScale() {
      if (this.clientW >= 750) {
        this.clientW = 414;
        this.clientH = 730;
      }
      if (
        this.clientH / this.clientW > 1.5 &&
        this.clientH / this.clientW < 1.6
      ) {
        this.screenParm = "smallScreen";
      } else if (this.clientH / this.clientW <= 1.5) {
        this.screenParm = "superSmallScreen";
      } else if (this.clientH / this.clientW >= 1.8) {
        this.screenParm = "bigScreen";
      } else {
        this.screenParm = "middleScreen";
      }
    },
  },
};
</script>
<style lang="less" scoped>
@base: 46.875rem;
#colum {
  background-size: 100% 100%;
  background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/columbg.png);
  position: relative;
  .topline {
    position: absolute;
    width: 703 / @base;
    left: 47 / @base;
    top: 0 / @base;
  }
  .bottomline {
    position: absolute;
    width: 645 / @base;
    left: 0 / @base;
    top: 46 / @base;
  }
  .flower {
    position: absolute;
    // width: 493/@base;
    // left: 125/@base;
    // top: 321/@base;
    width: 750 / @base;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
  }
  .newflash {
    position: absolute;
    width: 131 / @base;
    left: 324 / @base;
    top: 24 / @base;
    opacity: 1;
    transform: scale(1);
    
  }
  .process {
    position: absolute;
    width: 137 / @base;
    left: 150 / @base;
    top: 135 / @base;
    opacity: 1;
    transform: scale(1);
  }
  .voice {
    position: absolute;
    width: 129 / @base;
    left: 47 / @base;
    top: 332 / @base;
    transform: scale(1);
    opacity: 1;
  }
  .live {
    position: absolute;
    width: 136 / @base;
    left: 558 / @base;
    top: 727 / @base;
    transform: scale(1);
    opacity: 1;
  }
  .wqsd {
    position: absolute;
    width: 123 / @base;
    left: 495 / @base;
    top: 908 / @base;
    transform: scale(1);
    opacity: 1;
  }
  .industry {
    position: absolute;
    width: 112 / @base;
    left: 377 / @base;
    top: 1064 / @base;
    transform: scale(1);
    opacity: 1;
  }
  .service {
    position: absolute;
    width: 112 / @base;
    left: 195 / @base;
    top: 1171 / @base;
    transform: scale(1);
    opacity: 1;
  }
}
.big{
    animation: tada 2s linear infinite;
}
@keyframes tada {
  0% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }
  5%,
  10% {
    -webkit-transform: scale(0.9) rotate(-3deg);
    -ms-transform: scale(0.9) rotate(-3deg);
    transform: scale(0.9) rotate(-3deg);
  }
  15%,
  25%,
  35%,
  45% {
    -webkit-transform: scale(1.3) rotate(3deg);
    -ms-transform: scale(1.3) rotate(3deg);
    transform: scale(1.3) rotate(3deg);
  }
  20%,
  30%,
  40% {
    -webkit-transform: scale(1.3) rotate(-3deg);
    -ms-transform: scale(1.3) rotate(-3deg);
    transform: scale(1.3) rotate(-3deg);
  }
  50% {
    -webkit-transform: scale(1) rotate(0);
    -ms-transform: scale(1) rotate(0);
    transform: scale(1) rotate(0);
  }
  100% {
    -webkit-transform: scale(1) rotate(0);
    -ms-transform: scale(1) rotate(0);
    transform: scale(1) rotate(0);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Colum.vue